import { render, staticRenderFns } from "./af-form-address.vue?vue&type=template&id=cf53f8fa&"
import script from "./af-form-address.vue?vue&type=script&lang=ts&"
export * from "./af-form-address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports